import { React, useState, useEffect } from "react";
import { useFormik } from "formik";
import { Form, Row, Col, Button, Nav, InputGroup, Modal } from 'react-bootstrap';
import * as Yup from "yup";
import { Link, withRouter } from 'react-router-dom';
import '../../EmailProvider/Smtp/smtp.scss';
import EyeIcon from '../../../../assets/images/eye_icon.svg';
import { useMutation, useLazyQuery } from '@apollo/client';
import { SAVE_TWILLO, TEST_TWILLO } from '../../../../gql/twillio/mutation';
import { GET_TWILLIO_SAVED_DATA } from '../../../../gql/twillio/queries';
import { Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import warningIcon from '../../../../assets/images/warningIcon.svg';
import useUnsavedChangeWarning from 'hooks/useUnsavedChangeWarning';
import { REMOVE_TWILLIO } from '../../../../gql/twillio/mutation';

function Twilio({ history }) {

    const [twilioSid, setTwilioSID] = useState('')
    const [twilioToken, setTwilioToken] = useState('')
    const [toNumber, setToNumber] = useState('')
    const [twilioNumber, setTwilioNumber] = useState('')
    const [errorMessage, setErrorMessage] = useState('')
    const [enableTestButton, setEnableTestButton] = useState(false)

    const [testTwilloSuccess, setTestTwilloSuccess] = useState(false)
    const [saveTwilloSuccess, setSaveTwilloSuccess] = useState(false)
    const [passwordShown, setPasswordShown] = useState(false);

    const userInfo = JSON.parse(localStorage.getItem('user'))
    const tested = userInfo?.twilioTested
    const saved = userInfo?.twilioSaved
    const [twilioTested, setTwilioTested] = useState(tested);
    const [twilioSaved, setTwilioSaved] = useState(saved);

    const [smShow, setSmShow] = useState(false);
    const [showUnlikButton, setShowUnlinkButton] = useState(false);
    const [removed, setRemoved] = useState(false);
    const [Prompt, setIsDirty, setPristine] = useUnsavedChangeWarning()

    // Auth Token toggle handler
    const togglePassword = () => {
        // When the handler is invoked
        // inverse the boolean state of passwordShown
        setPasswordShown(!passwordShown);
    };

    const [saveTwillo, { loading, data: savedTwillioData }] = useMutation(SAVE_TWILLO, {
        onCompleted(data) {
            setSaveTwilloSuccess(true)
            setShowUnlinkButton(true)
        },
        onError(error) {
            if (error) {
                if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
                    setErrorMessage("Check Your Network, Your Browser Is Offline")
                }
                if (error.message) {
                    setErrorMessage(error.message)
                }
                if (!error.message) {
                    setErrorMessage("Something Went Wrong !")
                }
            }
        }
    })

    const [testTwillo, { loading: testLoading }] = useMutation(TEST_TWILLO, {
        onCompleted(data) {
            setTestTwilloSuccess(true)
        },
        onError(error) {
            if (error) {
                if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
                    setErrorMessage("Check Your Network, Your Browser Is Offline")
                }
                if (error.message) {
                    setErrorMessage(error.message)
                }
                if (!error.message) {
                    setErrorMessage("Something Went Wrong !")
                }
            }
        }
    })

    const [getSavedTwillo, { data }] = useLazyQuery(GET_TWILLIO_SAVED_DATA, {
        onCompleted(data) {
            setTwilioSID(data?.findTextSettings?.accountSid)
            setTwilioToken(data?.findTextSettings?.authToken)
            setToNumber(data?.findTextSettings?.toMobile)
            setTwilioNumber(data?.findTextSettings?.senderMobile)
        },
        fetchPolicy: "network-only",
    })

    const [removeTwillio] = useMutation(REMOVE_TWILLIO, {
        onCompleted(data) {
            if (data) {
                let user = {
                    ...userInfo,
                    twilioTested: false,
                    twilioSaved: false
                }
                localStorage.setItem('user', JSON.stringify(user))
                setTwilioTested(false)
                setRemoved(true)
            }
        },
        onError(error) {
            if (error) {
                if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
                    setErrorMessage("Check Your Network, Your Browser Is Offline")
                }
                if (error.message) {
                    setErrorMessage(error.message)
                }
                if (!error.message) {
                    setErrorMessage("Something Went Wrong !")
                }
            }
        }
    })

    useEffect(() => {
        getSavedTwillo()

        return () => {
            if (savedTwillioData) {
                let user = {
                    ...userInfo,
                    twilioSaved: true
                }
                localStorage.setItem('user', JSON.stringify(user))
            }
            else {
                let user = {
                    ...userInfo,
                    twilioSaved: false
                }
                localStorage.setItem('user', JSON.stringify(user))
            }
        }
        // eslint-disable-next-line
    }, [saveTwilloSuccess])


    const formik = useFormik({
        initialValues: {
            twilioSID: twilioSid,
            twilioToken: twilioToken,
            toNumber: toNumber,
            // twilioCountrycode: "",
            twilioNumber: twilioNumber,
        },
        enableReinitialize: true,
        validationSchema: Yup.object({
            twilioSID: Yup.string()
                .required("Account SID is required"),
            twilioToken: Yup.string()
                .required("Auth Token is required"),
            toNumber: Yup.string()
                .required("To number is required"),
            twilioNumber: Yup.string()
                .required("Sender number is required")
            // .matches(/^[\d+ ]*$/, "Sender number should contain numbers only")
            // .min(10, 'Sender number should contain 10 digits')
            // .max(10, 'Sender number should contain 10 digits')
            ,
        }),
        onSubmit: (values) => {
            const inputData = {
                accountSid: values.twilioSID,
                authToken: values.twilioToken,
                senderMobile: values.twilioNumber,
                toMobile: values.toNumber,
            }

            try {
                saveTwillo({
                    variables: {
                        createTextInput: inputData
                    }
                })
            }
            catch (e) {
                console.error(e)
            }
        }
    })

    const handleTestTwillio = () => {
        const inputData = {
            accountSid: formik.values.twilioSID,
            authToken: formik.values.twilioToken,
            senderMobile: formik.values.twilioNumber,
            toMobile: formik.values.toNumber,
        }

        testTwillo({
            variables: {
                createTextInput: inputData
            }
        })

    }


    if (testTwilloSuccess) {
        let user = {
            ...userInfo,
            twilioTested: true
        }
        localStorage.setItem('user', JSON.stringify(user))
        setTwilioTested(true)
        setTwilioSaved(true)

        toast.success("A Test Message Has Been Sent To Your Mobile Number. Please Check.", {
            position: "bottom-right",
            // closeOnClick: true,
            // autoClose: 1000,
        })
        setTestTwilloSuccess(false)
    }

    if (saveTwilloSuccess) {
        setPristine()
        let user = {
            ...userInfo,
            twilioSaved: true
        }
        localStorage.setItem('user', JSON.stringify(user))
        setTwilioSaved(true)
        toast.success("Successfully Saved.", {
            position: "bottom-right",
            // closeOnClick: true,
            // autoClose: 1000,
        })
        setSaveTwilloSuccess(false)
    }

    if (errorMessage) {
        // let user = {
        //     ...userInfo,
        //     twilioTested: false
        // }
        // localStorage.setItem('user', JSON.stringify(user))
        // setTwilioTested(false)
        toast.error(errorMessage, {
            position: "bottom-right",
            closeOnClick: true,
        })
        setErrorMessage('')
    }

    const handleFocus = () => {
        if (formik.values.toNumber && formik.values.twilioNumber && formik.values.twilioSID && formik.values.twilioToken) {
            setEnableTestButton(true)
        }
    }

    const handleUnlinkButton = () => {
        if (showUnlikButton || data) {
            return setSmShow(true)
        }
        if (!showUnlikButton || !data) {
            history.push('/settings/text-provider')

        }

        setSmShow(true)

    }

    const handleUnlink = () => {
        removeTwillio()
    }

    if (removed) {
        history.push('/settings/text-provider')
    }

    const handleTwillioChange = () => {
        setIsDirty()
    }

    return (
        <>
            <div>
                <h1 className='page-title'>Settings</h1>
                <Nav
                    className='setting-menu'
                >
                    <Nav.Item>
                        <Link to="/settings/user" className='nav-link'>User</Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Link to="/settings/email-provider" className='nav-link'>Email Provider</Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Link to="/settings/text-provider" className='nav-link active'>SMS Provider</Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Link to="/settings/email-signature" className='nav-link'>Email Signature</Link>
                    </Nav.Item>
                    {/* <Nav.Item>
                        <Link to="/settings/billing" className='nav-link'>Billing</Link>
                    </Nav.Item> */}
                </Nav>
                <div className="twilio-sec">
                    <div className="twilio_title_container" >
                        <h4>Sender settings</h4>
                        <button className='solid-button' onClick={handleUnlinkButton}>
                            <svg fill='#fff' width="20px" height="20px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" d="M5.63603897,5.63603897 L11.289,11.289 L13.4213562,9.15728753 C13.8138529,8.76479084 14.4502158,8.76479084 14.8427125,9.15728753 C15.2352092,9.54978421 15.2352092,10.1861471 14.8427125,10.5786438 L12.71,12.71 L18.363961,18.363961 C18.7544853,18.7544853 18.7544853,19.3876503 18.363961,19.7781746 C17.9734367,20.1686989 17.3402718,20.1686989 16.9497475,19.7781746 L14.139,16.968 L10.5786438,20.5281374 C8.61616033,22.4906209 5.43434601,22.4906209 3.47186258,20.5281374 C1.56102344,18.6172983 1.5107382,15.5504592 3.32100685,13.5787779 L3.47186258,13.4213562 L7.032,9.861 L4.22182541,7.05025253 C3.83130112,6.65972824 3.83130112,6.02656326 4.22182541,5.63603897 C4.6123497,5.24551468 5.24551468,5.24551468 5.63603897,5.63603897 Z M8.453,11.282 L4.89321881,14.8427125 C3.71572875,16.0202025 3.71572875,17.9292911 4.89321881,19.1067812 C6.02865566,20.242218 7.84436716,20.2827693 9.02839505,19.2284351 L9.15728753,19.1067812 L12.717,15.546 L11.296,14.125 L10.5786438,14.8427125 C10.1861471,15.2352092 9.54978421,15.2352092 9.15728753,14.8427125 C8.76479084,14.4502158 8.76479084,13.8138529 9.15728753,13.4213562 L9.875,12.704 L8.453,11.282 Z M20.5281374,3.47186258 C22.4906209,5.43434601 22.4906209,8.61616033 20.5281374,10.5786438 L17.6854249,13.4213562 C17.2929283,13.8138529 16.6565654,13.8138529 16.2640687,13.4213562 C15.871572,13.0288596 15.871572,12.3924967 16.2640687,12 L19.1067812,9.15728753 C20.2842712,7.97979746 20.2842712,6.07070887 19.1067812,4.89321881 C17.9292911,3.71572875 16.0202025,3.71572875 14.8427125,4.89321881 L12,7.73593129 C11.6075033,8.12842798 10.9711404,8.12842798 10.5786438,7.73593129 C10.1861471,7.3434346 10.1861471,6.70707174 10.5786438,6.31457505 L13.4213562,3.47186258 C15.3838397,1.50937914 18.565654,1.50937914 20.5281374,3.47186258 Z M12.7071068,9.87867966 L11.2928932,11.2928932 L12.7071068,12.7071068 L14.1213203,11.2928932 L12.7071068,9.87867966 Z" />
                            </svg>
                            Unlink SMS Provider
                        </button>
                    </div>
                    <Form className="logInForm twilio" onSubmit={formik.handleSubmit}>
                        {/*  */}
                        <Row className="mb-4">
                            <Form.Group as={Col} md="12" controlId="twilioSID">
                                <Form.Label>Twillio Account SID</Form.Label>
                                <Form.Control
                                    name="twilioSID"
                                    type="text"
                                    placeholder=""
                                    value={formik.values.twilioSID}
                                    onChange={formik.handleChange}
                                    onInput= {handleTwillioChange}
                                    onBlur={formik.handleBlur}
                                    onFocus={handleFocus}
                                    className={formik.errors.twilioSID && formik.touched.twilioSID && "error"}
                                />
                                {formik.errors.twilioSID && formik.touched.twilioSID && (
                                    <div className="input-feedback">{formik.errors.twilioSID}</div>
                                )}
                            </Form.Group>
                        </Row>

                        <Row className="mb-4">
                            <Form.Group className="pwd-wrapper" as={Col} md="12" controlId="twilioToken">
                                <Form.Label>Twillio Auth Token </Form.Label>
                                <Form.Control
                                    name="twilioToken"
                                    type={passwordShown ? "text" : "password"}
                                    placeholder=""
                                    value={formik.values.twilioToken}
                                    onChange={formik.handleChange}
                                    onInput= {handleTwillioChange}
                                    onBlur={formik.handleBlur}
                                    onFocus={handleFocus}
                                    className={formik.errors.twilioToken && formik.touched.twilioToken && "error"}
                                />
                                <span className={passwordShown ? "hide-pwd password-show" : "show-pwd password-show"} onClick={togglePassword}><img className="view-icon" src={EyeIcon} alt="view" /></span>
                                {formik.errors.twilioToken && formik.touched.twilioToken && (
                                    <div className="input-feedback">{formik.errors.twilioToken}</div>
                                )}
                            </Form.Group>
                        </Row>
                        <Row className="mb-4">
                            <InputGroup className="mb-3">
                                <Form.Label htmlFor="twilioNumber">Twillio Sender Number</Form.Label>
                                {/* <Form.Select name="twilioCountrycode" aria-label="select">
                                <option value="+1">+1</option>
                                <option value="+91">+91</option>
                            </Form.Select> */}
                                <Form.Control
                                    name="twilioNumber"
                                    type="text"
                                    placeholder="Eg: +1 0123456789"
                                    id="twilioNumber"
                                    value={formik.values.twilioNumber}
                                    onChange={formik.handleChange}
                                    onInput= {handleTwillioChange}
                                    onBlur={formik.handleBlur}
                                    onFocus={handleFocus}
                                    className={formik.errors.twilioNumber && formik.touched.twilioNumber && "error"}
                                />
                                {formik.errors.twilioNumber && formik.touched.twilioNumber && (
                                    <div className="input-feedback">{formik.errors.twilioNumber}</div>
                                )}
                            </InputGroup>
                        </Row>

                        <Row className="mb-4">
                            <InputGroup className="mb-3">
                                <Form.Label htmlFor="toNumber">To Number</Form.Label>
                                <Form.Control
                                    name="toNumber"
                                    type="text"
                                    placeholder="Eg: +1 0123456789"
                                    id="toNumber"
                                    value={formik.values.toNumber}
                                    onChange={formik.handleChange}
                                    onInput= {handleTwillioChange}
                                    onBlur={formik.handleBlur}
                                    onFocus={handleFocus}
                                    className={formik.errors.toNumber && formik.touched.toNumber && "error"}
                                />
                                {formik.errors.toNumber && formik.touched.toNumber && (
                                    <div className="input-feedback">{formik.errors.toNumber}</div>
                                )}
                            </InputGroup>
                        </Row>
                        {
                            testLoading ?
                                <Button className='solid-button test-btn' disabled={!formik.dirty || !formik.isValid}>Test
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                </Button>
                                :
                                // <Button className='solid-button test-btn' onClick={handleTestTwillio} disabled={data ? false : (!formik.dirty || !formik.isValid) }>Test</Button>
                                <Button className='solid-button test-btn' onClick={handleTestTwillio} disabled={enableTestButton === true ? false : (!formik.dirty || !formik.isValid)}>Test</Button>
                            // <Button className='solid-button' onClick={handleTestTwillio} >Test</Button>
                        }
                        {
                            loading ?
                                <Button className='solid-button' disabled={!formik.dirty || !formik.isValid}>Save &nbsp;
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                </Button>
                                :
                                // <Button className='solid-button' type="submit" disabled={!formik.dirty || !formik.isValid}>Save</Button>
                                // <Button className='solid-button' type="submit" disabled={twilioTested == true ? false : false} >Save</Button>
                                <Button className='solid-button' type="submit" disabled={!twilioTested || !twilioSaved} >Save</Button>
                            // <Button className='solid-button' type="submit" >Save</Button>
                        }
                    </Form>
                </div>
                <div>
                    <Modal
                        size="md"
                        className='warning-modal'
                        show={smShow}
                        onHide={() => setSmShow(false)}
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                    >
                        <Modal.Body>
                            <div className='warning-div'>
                                <img src={warningIcon} alt="warning" />
                                <h2>Remove Twillio Account</h2>
                                <p>Removing your Twillio Account could stop your campaigns if you're using this set up. Are you sure?
                                </p>
                                <div className='btn-container'>
                                    <button className='cancel-btn' onClick={() => setSmShow(false)}>Cancel</button>
                                    <button className='solid-button' onClick={handleUnlink} >Unlink Now</button>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>
                </div>
            </div>
            {Prompt}
        </>
    )
}

export default withRouter(Twilio);
